import { type Course, type CourseSummary, type Skill, type SkillCategory, type SvelteFetch } from '$lib/api/types';
import { fetchJson, getJson } from '$lib/api/fetch';

export async function listCourses(search: string, page: number, pageSize = 20, signal?: AbortSignal): Promise<CourseSummary[]> {
  return await getJson(`/courses?search=${search}&page=${page}&pageSize=${pageSize}`, signal);
}

export async function getCourse(id: number, svelteFetch: SvelteFetch): Promise<Course> {
  return await getJson(`/courses/${id}`, undefined, svelteFetch);
}

export async function updateCourse(id: number, course: Pick<Course, 'name' | 'code'>): Promise<Course> {
  return await fetchJson(`/courses/${id}`, 'PUT', course);
}

export async function createCourse(course: Pick<Course, 'name' | 'code'>): Promise<Course> {
  return await fetchJson(`/courses`, 'POST', course);
}

export async function deleteCourse(id: number): Promise<Course> {
  return await fetchJson(`/courses/${id}`, 'DELETE', undefined);
}

export async function createSkillCategory(
  courseId: number,
  category: Pick<SkillCategory, 'name' | 'badge'>,
): Promise<SkillCategory> {
  return await fetchJson(`/courses/${courseId}/categories`, 'POST', category);
}

export async function updateSkillCategory(
  courseId: number,
  categoryId: number,
  category: Pick<SkillCategory, 'name' | 'badge'>,
): Promise<SkillCategory> {
  return await fetchJson(`/courses/${courseId}/categories/${categoryId}`, 'PUT', category);
}

export async function deleteSkillCategory(courseId: number, categoryId: number): Promise<SkillCategory> {
  return await fetchJson(`/courses/${courseId}/categories/${categoryId}`, 'DELETE', undefined);
}

export async function createSkill(
  courseId: number,
  categoryId: number,
  skill: Pick<Skill, 'name' | 'description' | 'pointsValue'>,
): Promise<Skill> {
  return await fetchJson(`/courses/${courseId}/categories/${categoryId}/skills`, 'POST', skill);
}

export async function updateSkill(
  courseId: number,
  categoryId: number,
  skillId: number,
  skill: Pick<Skill, 'name' | 'description' | 'pointsValue'>,
): Promise<Skill> {
  return await fetchJson(`/courses/${courseId}/categories/${categoryId}/skills/${skillId}`, 'PUT', skill);
}

export async function deleteSkill(courseId: number, categoryId: number, skillId: number): Promise<Skill> {
  return await fetchJson(`/courses/${courseId}/categories/${categoryId}/skills/${skillId}`, 'DELETE', undefined);
}
